import { CocPageType } from "../types/coc.type";

export interface ICocUserDetails {
  key?: string;
  date: string;
  date_formatted: string;
  page: CocPageType;
  uuid?: string;
  is_virtual?: boolean;
  manufacturer?: string;
  model?: string;
  platform?: string;
  serial?: string;
  version?: string;
}